<template>
    <div v-if="app.WholeSaler.isWholeSaler" class="d-flex flex-column align-items-center justify-content-center mb-4">
        <!-- NOTICE  -->
        <div class="mb-4 col-12 col-md-8 mb-3 alert alert-secondary" v-html="$t('s4_wholesaler_notice')">
        </div>

        <!-- WholeSaler -->
        <button type="button" class="btn btn-success mt-2 text-center btn_bottom_width"
            @click="app.WholeSaler.sendToCart()" :disabled="app.WholeSaler.isSending">
            {{ app.translate("sendToCart_button") }}
        </button>

        <button type="button" class="btn btn-outline-secondary mt-3 text-center btn_bottom_width"
            @click="navigateToLastStage()">

            {{ $t('modify_configuration_btn') }}
        </button>

    </div>
</template>
<script>
import { app } from "../../application.js";

export default {
    name: "sendToWholeSaler",

    data() {
        return {
            app: app
        };
    },

    methods: {
        navigateToLastStage: function () {
            if (
                this.idgama === '77' ||
                this.idgama === '88' ||
                this.idgama === '07' ||
                this.idgama === '22-0' ||
                this.idgama === '22' ||
                this.idgama === '22hd' ||
                this.idgama === '22-1' ||
                this.idgama === '22dt'
            ) {
                app.navigateToStageAsync('2')
            } else {
                app.navigateToStageAsync('3')
            }
        },
    },
    created() {
        this.idgama = app.currentConfiguration.familyParameters["gama"].value.id;
    },
};
</script>

<style lang="scss" scoped>
.btn_bottom_width {
    width: 270px;
}
</style>
